import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DialogService } from 'src/app/shared/services/dialog.service';

@Component({
  selector: 'app-new-message-button',
  templateUrl: './new-message-button.component.html',
  styleUrls: ['./new-message-button.component.scss']
})
export class NewMessageButtonComponent implements OnInit {
  @Input() userId!: string;
  @Input() residentId!: string;

  constructor(private router: Router, private dialogService: DialogService) {}

  ngOnInit() {}

  public newConversation() {
    this.dialogService.closeAllDialogs();
    this.router.navigate(['/messages/active'], { queryParams: { userId: this.userId, residentId: this.residentId } });
  }
}
